import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * CustomerDashboard: Minimal redirect component
 * Legacy dashboard - now redirects to /customer/deliveries on mount
 * All functionality split into FoodsPage and DeliveriesPage
 * This component is preserved for backward compatibility with direct URL navigation
 */
function CustomerDashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to deliveries (new default landing page)
    navigate('/customer/deliveries', { replace: true });
  }, [navigate]);

  // Loading fallback while redirect happens
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
        <p className="text-gray-500">Redirecting...</p>
      </div>
    </div>
  );
}

export default CustomerDashboard;
